import React from "react";
import SearchIcon from "../assets/images/search-normal.svg";

const SearchInput = ({ filterInput, handleFilterChange, className }) => {
  return (
    <div className={`relative w-[200px] xl:w-[270px] ${className}`}>
      <input
        type="text"
        className="h-11 px-5 w-full pl-10 border border-[#2E37A4] bg-gray-50 rounded-lg text-gray-900 ring-0 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-0 outline-none focus:ring-inset focus:ring-indigo-600"
        placeholder="Search here"
        value={filterInput}
        onChange={handleFilterChange}
      />
      <span className="absolute left-2.5 top-2.5">
        <img src={SearchIcon} alt="" />
      </span>
    </div>
  );
};

export default SearchInput;
